module.exports = __webpack_public_path__ + "img/partners5.34505021.png";